import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js/config.js';
export default {
    getCommissionDetail(year, month){
        var commissionUrl = OrderCircle_CONFIG.API_URL + 'staff-commissions/'+ year + '/'+ month;
        return Axios.get(`${commissionUrl}`);
    },
    getLast30DaysOrdersAndRevenue(token){
    	var orderAndRevenueUrlFor30Days = OrderCircle_CONFIG.API_URL + 'stats/orders-revenue-30-days';
    	return Axios.get(`${orderAndRevenueUrlFor30Days}`);
    },
    patchToggleOnboarding(data, token){
      var updateOnBoarding = OrderCircle_CONFIG.API_URL + 'toggle-onboarding';
        return Axios.patch(`${updateOnBoarding}`, data,);  
    },
    DateCheck(data, token){
        var dateCheck = OrderCircle_CONFIG.API_URL + 'date-check';
        return Axios.post(`${dateCheck}`, data);
    },
    getDashboardData(token, dateRange = null){
        var dashboardData = OrderCircle_CONFIG.API_URL + 'centerlized-dashboard-data';
        return Axios.get(`${dashboardData}`, {
            params: dateRange ? {start_date: dateRange.start_date, end_date: dateRange.end_date} : {}
        });
    },
    getWidgetData(token){
        var widgetData = OrderCircle_CONFIG.API_URL + 'get-widget-data';
        return Axios.get(`${widgetData}`);
    },  
    getBrandSkins(token){
        var brandSkin = OrderCircle_CONFIG.API_URL + 'get-brandSkin-data';
        return Axios.get(`${brandSkin}`);
    },
}